import { useGlobalPopupStore } from 'stores/globalPopups/globalPopups';

export function GlobalPopup() {
  const { popup } = useGlobalPopupStore();
  return <div className="flex size-full flex-col items-center justify-center">{popup ?? null}</div>;
}
